<template>
	<div style="width: 1400px;margin: 20px auto;background-color: #fff;padding: 30px;" v-html="about_us.content">

	</div>
</template>

<script>
	export default {
		data() {
			return {
				about_us: ''
			}
		},
		created() {
			this.getdata()
		},
		methods: {
			getdata() {
				this.$http({
					url: '/api/Product/ArticleDetail',
					data: {
						id: this.$route.query.id
					}
				}).then(res => {
					this.about_us = res.data
				})
			}
		}
	}
</script>

<style lang="scss">

</style>
